import { LocationIcon } from "./icons/LocationIcon";
import SectionCard from "./section-card";
import SectionHeader from "./section-header";

const NEUTRAL_500 = "#767c83";

/*
 * The "Show on the map" action is a fixed accent that must not follow the
 * user's primary color, matching the Business address action (`text-[#0E80FF]`).
 */
const MAP_ACTION_COLOR = "#0E80FF";

const EventAddressCard = ({
  address,
  title,
  showMapLabel,
  onShowMap,
  titleFont,
  textFont,
}) => {
  if (!address) return null;

  return (
    <SectionCard
      className="flex w-full flex-col items-center justify-center p-[10px]"
      id="locationBlock"
    >
      <SectionHeader
        icon={<LocationIcon size={24} color={NEUTRAL_500} />}
        title={title}
        titleFont={titleFont}
        className="space-x-[10px] xs:space-x-[17px]"
        titleClassName="text-base xs:text-base"
      />
      <div className="mb-[15px] h-px w-full rounded-full bg-event-85" />
      <div className="mb-[10px] mt-[20px] flex w-full flex-col items-start justify-center space-y-[4px] px-[10px]">
        <p
          className="word-break-fix text-left text-sm text-event-500 xs:text-base rtl:text-right"
          style={textFont ? { fontFamily: textFont } : undefined}
        >
          {address}
        </p>
      </div>
      <div className="flex w-full flex-row items-start px-[10px]">
        <button
          type="button"
          onClick={onShowMap}
          className="cursor-pointer text-base font-medium xs:text-lg"
          style={{ color: MAP_ACTION_COLOR, fontFamily: textFont }}
        >
          {showMapLabel}
        </button>
      </div>
    </SectionCard>
  );
};

export default EventAddressCard;
